import { jsx } from "react/jsx-runtime";
import { SimonForm } from "@zillow/zrs-cms";
import "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const BlockSimonForm = ({
  attrs,
  index,
  innerBlocks
}) => {
  const {
    id,
    persona,
    storageEnvironment = "Zillow",
    subscriptionListName,
    treatmentName
  } = attrs;
  return /* @__PURE__ */ jsx(SimonForm, { id, persona, storageEnvironment, subscriptionListName, treatmentName, children: generateBlockList({
    blocks: innerBlocks
  }) }, index);
};
export {
  BlockSimonForm as default
};
